/** @file Local channel names (bone.setTransform / animation.setKey) and their POSE_LAYOUT offsets. */
import { POSE_LAYOUT } from '@pose2d/core/contracts/pose';

/** A bone's local channel, named as the commands name it. */
export type LocalChannel = 'x' | 'y' | 'rotation' | 'scaleX' | 'scaleY' | 'shearX' | 'shearY';
/** Absolute local values a drag previews for one bone. */
export type PreviewValues = Partial<Record<LocalChannel, number>>;

/** Offset of each channel inside a LOCAL_STRIDE block. */
export const CHANNEL_OFFSET: Readonly<Record<LocalChannel, number>> = {
  x: POSE_LAYOUT.X, y: POSE_LAYOUT.Y, rotation: POSE_LAYOUT.ROTATION, scaleX: POSE_LAYOUT.SCALE_X,
  scaleY: POSE_LAYOUT.SCALE_Y, shearX: POSE_LAYOUT.SHEAR_X, shearY: POSE_LAYOUT.SHEAR_Y,
};
